<template>
<div class="kdx-project-introduce">
    <div class="pc-project-main">
        <div class="nav-crumb-top">
            <i class="wl-icon-zhuye1" style="color:#05243D;margin-right:8px;"></i>
            <span>首页</span>/
            <span style="color:#027B52">项目介绍</span>
        </div>
        <div class="project-content-layer">
            <div class="project-content-title">餐饮管理运行职业技能等级证书</div>
            <div class="project-content">
                <p>继国务院发布《职教二十条》后，日前，教育部、发改委、财政部、市场监管总局联合印发了《关于在院校实施“学历证书+若干职业技能等级。</p>
                <p>根据《试点方案》要求，从今年起，面向现代农业、先进制造业、现代服务业、战略性新兴产业等20个技能人才紧缺领域，近期将首批启动5个职业技能领域试点，其中包括建筑工程技术、信息与通信技术、物流管理、老年服务与管理、汽车运用与维修技术将率先进入等级证书制度。</p>
                <p>《试点方案》还要求，等级证书的颁发和评价机构将面向社会招募，但不得违规收取或变相收取任何费用。</p>
                <p>职业技能等级证书以社会需求、企业岗位需求和职业技能等级标准为依据，对学习者职业技能进行综合评价，如实反映学习者职业技术能力，证书分为初级、中级、高级。</p>
                <p>《试点方案》规定，院校是1+X证书制度试点的实施主体。中等职业单位、高等职业单位可结合初级、中级、高级职业技能等级开展培训评价工作，试点院校在面向本校学生开展培训的同时，积极为社会成员提供培训服务。社会成员自主选择证书类别、等级，在试点院校内、外进行培训。 </p>
                <p>教育部同时建立“学分银行”制度，建设信息系统，学生和社会成员在按规定程序进入试点院校接受相关专业学历教育时，可按规定兑换学分，免修相应课程，促进学历证书与职业技能等级证书互通。</p>
            </div>
        </div>
    </div>
    <div class="ph-project-main">
        <div class="crumbs-text">
            <div style="padding:0 20px;">
                <i style="color:#05243D" class="wl-icon-zhuye1"></i>
                <span @click="goHome" style="cursor: pointer;">首页</span>
                <span>></span>
                <span style="color:#05243D">项目介绍</span>
            </div>
        </div>
        <div class="project-content-view">
            <div class="project-title-con">餐饮管理运行职业技能等级证书</div>
            <div class="project-content-con">
                <p>继国务院发布《职教二十条》后，日前，教育部、发改委、财政部、市场监管总局联合印发了《关于在院校实施“学历证书+若干职业技能等级。</p>
                <p>根据《试点方案》要求，从今年起，面向现代农业、先进制造业、现代服务业、战略性新兴产业等20个技能人才紧缺领域，近期将首批启动5个职业技能领域试点，其中包括建筑工程技术、信息与通信技术、物流管理、老年服务与管理、汽车运用与维修技术将率先进入等级证书制度。</p>
                <p>《试点方案》还要求，等级证书的颁发和评价机构将面向社会招募，但不得违规收取或变相收取任何费用。</p>
                <p>职业技能等级证书以社会需求、企业岗位需求和职业技能等级标准为依据，对学习者职业技能进行综合评价，如实反映学习者职业技术能力，证书分为初级、中级、高级。</p>
                <p>《试点方案》规定，院校是1+X证书制度试点的实施主体。中等职业单位、高等职业单位可结合初级、中级、高级职业技能等级开展培训评价工作，试点院校在面向本校学生开展培训的同时，积极为社会成员提供培训服务。社会成员自主选择证书类别、等级，在试点院校内、外进行培训。 </p>
                <p>教育部同时建立“学分银行”制度，建设信息系统，学生和社会成员在按规定程序进入试点院校接受相关专业学历教育时，可按规定兑换学分，免修相应课程，促进学历证书与职业技能等级证书互通。</p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    created() {

    },
    methods: {
        goHome() {
            this.$router.push({
                name: "xHome"
            });
        }
    }
}
</script>

<style lang="scss">
.kdx-project-introduce {
    width: 1200px;
    margin: 0 auto;

    .nav-crumb-top {
        margin-top: 23px;
    }

    .project-content-layer {
        margin-top: 30px;
        background: #F0F0F0;
        border-top: 4px solid #05243D;
        padding: 40px;

        .project-content-title {
            text-align: center;
            color: #05243D;
            font-size: 18px;
            margin: 15px 0 52px 0;
            font-weight: bold;
        }

        .project-content {
            color: #646464;
            font-size: 14px;
            line-height: 23px;

            p {
                margin-bottom: 20px;
            }
            img {
                display: block !important;
                margin: 20px auto !important;
                max-width: 90% !important;
            }
        }
    }

    .ph-project-main {
        display: none;
    }
}

@media only screen and(max-width:768px) {
    .kdx-project-introduce {
        width: auto;

        .pc-project-main {
            display: none;
        }

        .ph-project-main {

            display: block;

            .nav-crumb-top {
                margin: 0;
            }

            .crumbs-text {
                background: #F5F7FB;
                height: 40px;
                line-height: 40px;
                color: #666;

                span {
                    margin: 0 3px;
                }
            }

            .project-content-view {
                padding: 10px;
                background: #fff;
            }

            .project-title-con {
                text-align: center;
                color: #05243D;
                font-weight: bold;
            }

            .project-content-con {
                p {
                    margin-top: 10px;
                    text-indent: 20px;
                }
            }
        }
    }
}
</style>
